const PERIODS = [
  ["change24h", 0.5],
  ["change7d", 0.3],
  ["change30d", 0.2],
];

const NOISE_FLOOR = 0.05;

function availableChanges(asset = {}) {
  return PERIODS
    .map(([key, weight]) => ({ raw: asset?.[key], weight }))
    .filter(({ raw }) => raw !== null && raw !== undefined && raw !== "")
    .map(({ raw, weight }) => ({ value: Number(raw), weight }))
    .filter(({ value }) => Number.isFinite(value));
}

export function classifyRecentDirection(asset = {}) {
  const available = availableChanges(asset);

  if (!available.length) return "unavailable";

  const totalWeight = available.reduce((sum, item) => sum + item.weight, 0);
  const score = available.reduce((sum, item) => sum + item.value * item.weight, 0) / totalWeight;

  if (Math.abs(score) <= NOISE_FLOOR) return "mixed";
  return score > 0 ? "bullish" : "bearish";
}

export function recentDirectionScore(asset = {}) {
  const available = availableChanges(asset);

  if (!available.length) return null;

  const totalWeight = available.reduce((sum, item) => sum + item.weight, 0);
  return available.reduce((sum, item) => sum + item.value * item.weight, 0) / totalWeight;
}
